import { connect } from 'react-redux'
import { appleHealthIntegration, endIntegration, syncIntegration } from '../../common/integration/integrationActions'
import { changeUserLanguage } from '../../common/language/languageActions'
import { IGlobalState } from '../../Root/store/appReducer'
import { Settings } from './Settings'
import {
  changePassword,
  deleteUser,
  getUserCompanyCountries,
  getCompanyDivisions,
  updateUser,
  joinCompany,
  joinCompanySuccess,
  setUserDivision,
  setUserCountry,
  leaveCompany,
  togglePublicStatus,
  deleteUserOwnedCompany,
  setScreenOrientation,
} from './store/SettingsActions'
import {
  //userActivitySelector,
  companyCountriesSelector,
  companyDivisionsSelector,
  userDtoSelector,
  getChangePasswordFailCount,
  getChangePasswordOldPasswordError,
} from './store/SettingsSelectors'
import { hasRole, hasRoleInCompany, getUserCompanies } from '../../common/auth/authSelectors'
import { CompanyId, Role } from '../../services/api.types'
import { getWhoAmI } from '../../common/auth/authActions'
import {
  registerHealthConnect,
  setOnboardingStatusToActivityData,
  setOnboardingStatusToIntegration,
} from '../RegisterUser/store/RegisterUserActions'

const mapStateToProps = (state: IGlobalState) => ({
  hasRole: (role: Role) => hasRole(state, role),
  //activity: userActivitySelector(state),
  userDto: userDtoSelector(state),
  countries: companyCountriesSelector(state),
  divisions: companyDivisionsSelector(state),
  userCompanies: getUserCompanies(state),
  hasRoleInCompany: (companyId: CompanyId, role: Role) => hasRoleInCompany(state, companyId, role),
  changePasswordFailCount: getChangePasswordFailCount(state),
  changePasswordOldPasswordError: getChangePasswordOldPasswordError(state),
})

const mapDispatchToProps = {
  appleHealthIntegration,
  registerHealthConnect,
  changePassword,
  changeUserLanguage,
  deleteUser,
  syncIntegration,
  updateUser,
  getUserCompanyCountries,
  getCompanyDivisions,
  joinCompany,
  joinCompanySuccess,
  leaveCompany,
  deleteUserOwnedCompany,
  setUserDivision,
  setUserCountry,
  endIntegration,
  togglePublicStatus,
  getWhoAmI,
  setOnboardingStatusToIntegration,
  setOnboardingStatusToActivityData,
  setScreenOrientation,
}

export default connect(mapStateToProps, mapDispatchToProps)(Settings)
